import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Link } from 'react-router-dom'
import { Badge, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Header from '../../components/Header'
import Page from '../../components/Page'
import Paginator from '../../components/Paginator'
import Sorter, { SortControl } from '../../components/Sorter'
import StickyTable from '../../components/StickyTable'
import { useQsFilters } from '../../hooks/filters'
import { Tema } from '../../types'
import { useDeleteTema, useTemi } from '../../hooks/temi'

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  ordering: params.get('ordering') ?? '',
  search: params.get('search') ?? '',
  has_descrizione: params.get('has_descrizione') ?? '',
})

export default function TemiList() {
  const { filters, uiFilters, setFilters, setFiltersDebounced } =
    useQsFilters(initFilters)
  const { data } = useTemi(filters)
  const deleteTema = useDeleteTema()
  const [modalRm, modalRmActions] = useModalTrigger<Tema>()

  return (
    <Page padded>
      <Header>
        <div className="d-flex align-items-end">
          <h2 className="m-0">Temi</h2>
          <div className="counter ms-2 mb-1">
            <small>
              {data!.count}
              {' / '}
              {data!.total_count}
            </small>
          </div>
        </div>
        <Link className="btn btn-primary" to="/temi/new">
          <i className="bi bi-plus-circle me-2"></i> Aggiungi
        </Link>
      </Header>
      <div className="d-flex mt-3 mb-3 align-items-center">
        <input
          placeholder="Cerca"
          className="form-control w-auto"
          type="text"
          value={uiFilters.search}
          onChange={(e) =>
            setFiltersDebounced({ search: e.target.value, page: 1 })
          }
        />
        <select
          className="form-select w-auto ms-2"
          value={uiFilters.has_descrizione}
          onChange={(e) =>
            setFilters({ has_descrizione: e.target.value, page: 1 })
          }
        >
          <option value="">Tutti</option>
          <option value="true">Con descrizione</option>
          <option value="false">Senza descrizione</option>
        </select>
      </div>
      <StickyTable className="flex-1">
        <Sorter
          value={uiFilters.ordering}
          onSortChange={(ordering) =>
            setFilters({
              ordering,
              page: 1,
            })
          }
        >
          <thead>
            <tr>
              <th>#</th>
              <th>
                <div className="d-flex align-items-center">
                  Nome
                  <SortControl field={'name'} />
                </div>
              </th>
              <th>
                Descrizione
              </th>
              <th>
                <div className="d-flex align-items-center">Numero classi</div>
              </th>
              <th></th>
            </tr>
          </thead>
        </Sorter>
        <tbody>
          {data!.results.map((tema) => (
            <tr key={tema.id}>
              <td>{tema.id}</td>
              <td>
                <Link to={`/temi/${tema.id}`}>{tema.nome}</Link>
              </td>
              <td>
                {tema.descrizione ? (
                  <Badge color="primary">Si</Badge>
                ) : (
                  <Badge color="danger">No</Badge>
                )}
              </td>
              <td>
                <Link to={`/classi?tema=${tema.id}`}>
                {tema.numero_classi}
                </Link>
              </td>
              <td>
                <i
                  onClick={() => modalRmActions.open(tema)}
                  className="bi cursor-pointer text-danger bi-trash3-fill"
                ></i>
              </td>
            </tr>
          ))}
        </tbody>
      </StickyTable>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il tema {modalRm.value.nome} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteTema.isLoading}
            onClick={async () => {
              await deleteTema.mutateAsync(modalRm.value!.id)
              modalRmActions.close()
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
      <div className="position-relative">
        <Paginator
          count={data!.count}
          currentPage={uiFilters.page}
          goToPage={(page) => setFilters({ page })}
        />
      </div>
    </Page>
  )
}
